<template>
  <div>
    <Search ref="search" @on-search="onSearch" @on-reset="onReset" />

    <SearchType
      ref="searchType"
      class="search-Type"
      :data="searchTypeData"
      @change-list="changeList"
      @on-reset="onReset"
    />

    <div class="sample-list" v-loading="tableLoading">
      <SortFilterBtn
        ref="sortFilterBtn"
        :showBtnList="['xp', 'jg']"
        @change-list="sortChangeList"
      />
      <GoodBox :GoodData="tableData.list" />
      <Pagination
        :pageNo="tableParam.pageNo"
        :pageSize="tableParam.pageSize"
        :total="tableData.total"
        @handlePageChange="handlePageChange"
      />
    </div>
  </div>
</template>
<script>
import GoodBox from '@/components/GoodBox';
import Pagination from '@/components/Pagination';
import SearchType from './SearchType';
import Search from './Search';
import SortFilterBtn from '@/components/SortFilterBtn';

export default {
  components: { Search, SearchType, GoodBox, Pagination, SortFilterBtn },
  props: {},
  data() {
    const {
      fabric_category,
      fabric_type,
    } = this.$store.getters.allDictListData.data;
    return {
      searchVal: '',
      tableParam: {
        pageNo: 1,
        pageSize: 10,
        data: {
          keyWords: '',
          fabricTypeList: [],
          fabricCategoryList: [],
        },
      },
      searchTypeData: [
        {
          label: '膜布分类',
          name: 'mbflActiveName',
          list: fabric_category,
          tag: 'CheckboxGroup',
        },
        {
          label: '膜布类型',
          name: 'mblxActiveName',
          list: fabric_type,
          tag: 'CheckboxGroup',
        },
      ],
      tableData: {},
      tableLoading: false,
    };
  },
  mounted() {},
  methods: {
    getList() {
      this.tableLoading = true;
      this.$http.sampleApply
        .getFabricListPage(this.tableParam)
        .then(result => {
          this.tableData = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 分页
    handlePageChange({ pageNo, pageSize }) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getList();
    },
    inputChange(val) {
      this.tableParam.data.keyWords = val;
    },
    onSearch(val) {
      this.tableParam.data.keyWords = val;
      this.tableParam.pageNo = 1;
      this.getList();
    },
    changeList(val, name) {
      let data = this.tableParam.data;
      data.keyWords = this.$refs.search.value;
      if (name === 'mbflActiveName') {
        data.fabricCategoryList = val;
      }
      if (name === 'mblxActiveName') {
        data.fabricTypeList = val;
      }
      this.getList();
    },
    sortChangeList(name, val) {
      let data = this.tableParam.data;
      delete data.newSort;
      delete data.priceSort;
      delete data.capacitySort;
      data[name] = val;
      this.getList();
    },
    onReset() {
      let data = this.tableParam.data;
      delete data.newSort;
      delete data.priceSort;
      delete data.capacitySort;
      data.fabricTypeList = [];
      data.fabricCategoryList = [];
      this.searchTypeData.map(item => {
        this.$refs.searchType.$refs[item.name][0].onReset();
      });
      this.$refs.sortFilterBtn.onReset();
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .sample-list {
  max-width: 1170px;
  .el-tabs__item {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
  }
  .el-tabs__nav {
    height: 30px;
  }
  #tab-jg {
    padding-left: 10px !important;
  }
  #tab-rl {
    padding-right: 10px !important;
  }
}
.search-Type {
  border: 1px solid #ddd;
  padding: 0 10px 5px 10px;
}
</style>
